import '../css/navbar.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { secureStorage } from "../SecureStorage";

function NavBar({ orgId, onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 🧠 Check login state properly
  useEffect(() => {
    const storedToken = secureStorage.getItem('auth_token');
    // const storedToken = localStorage.getItem('token');
    const storedOrgId = secureStorage.getItem('orgId');
    setIsLoggedIn(Boolean(orgId || (storedToken && storedOrgId)));
  }, [orgId]);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleLogoutClick = () => {
    onLogout?.(); // optional chaining for safety
    closeMenu();
    setIsLoggedIn(false);
  };

  return (
    <nav className="navbar">
      {/* --- Left Side (Brand) --- */}
      <div className="navbar-brand flex items-center gap-2">
        <Link to="/" className="navbar-title flex items-center gap-2" onClick={closeMenu}>
          <img 
            src="/querybox_logo_blue_30.svg" 
            alt="QueryBox Logo" 
            className="h-8 w-8 mr-3"
          />
          QueryBox
        </Link>
      </div>

      {/* --- Hamburger (for mobile) --- */}
      <button className="hamburger" onClick={toggleMenu}>
        {menuOpen ? '✖' : '☰'}
      </button>

      {/* --- Links --- */}
      <div className={`navbar-links ${menuOpen ? 'show' : ''}`}>
        <a
          href={process.env.REACT_APP_MAIN_SITE || "https://querybox.app"}
          className="nav-link"
          onClick={closeMenu}
        >
          Home
        </a>
        <Link to="/pricing" className="nav-link" onClick={closeMenu}>Pricing</Link>
        <Link to="/how-to-use" className="nav-link" onClick={closeMenu}>How to Use</Link>

        {isLoggedIn && (
          <Link to="/dashboard" className="nav-link" onClick={closeMenu}>Dashboard</Link>
        )}

        {isLoggedIn ? (
          <button className="logout-btn" onClick={handleLogoutClick}>
            Logout
          </button>
        ) : (
          <>
            <Link to="/auth/login" className="nav-link login" onClick={closeMenu}>Login</Link>
            <Link to="/auth/signup" className="nav-link signup" onClick={closeMenu}>Signup</Link>
          </>
        )}
      </div>
    </nav>
  );
}

export default NavBar;


// // import '../App.css';
// import '../css/navbar.css';
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// function NavBar({ orgId, onLogout }) {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setMenuOpen((prev) => !prev);
//   };

//   const closeMenu = () => {
//     setMenuOpen(false);
//   };

  

//   return (
//     <nav className="navbar">
//       <div className="navbar-brand flex items-center gap-2">
//         <Link to="/" className="navbar-title flex items-center gap-2" onClick={closeMenu}>
//           {/* Logo from public folder */}
//           <img 
//             src="/querybox_logo_blue_30.svg" 
//             alt="QueryBox Logo" 
//             className="h-8 w-8 mr-3"
//           />
//           QueryBox
//         </Link>
//       </div>

//       {/* <div className="navbar-brand">
//         <Link to="/" className="navbar-title" onClick={closeMenu}>
//           QueryBox
//         </Link>
//       </div> */}

//       {/* Hamburger button (only visible on mobile via CSS) */}
//       <button className="hamburger" onClick={toggleMenu}>
//         {menuOpen ? '✖' : '☰'}
//       </button>

//       <div className={`navbar-links ${menuOpen ? 'show' : ''}`}>
//         <a
//           href={process.env.REACT_APP_MAIN_SITE || "https://querybox.app"}
//           className="nav-link"
//           onClick={closeMenu}
//         >
//           Home
//         </a>
//         {/* <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link> */}
//         <Link to="/pricing" className="nav-link" onClick={closeMenu}>Pricing</Link>
//         <Link to="/how-to-use" className="nav-link" onClick={closeMenu}>How to Use</Link>
//         {orgId && (
//           <Link to="/dashboard" className="nav-link" onClick={closeMenu}>Dashboard</Link>
//         )}
//         {orgId ? (
//           <button className="logout-btn" onClick={() => { onLogout(); closeMenu(); }}>
//             Logout
//           </button>
//         ) : (
//           <>
//             <Link to="/auth/login" className="nav-link login" onClick={closeMenu}>Login</Link>
//             <Link to="/auth/signup" className="nav-link signup" onClick={closeMenu}>Signup</Link>
//           </>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default NavBar;

